export default __webpack_public_path__ + "static/media/krisi_s.4419ee80.jpg";